<template>
  <div>
    <div class="header">
      <el-image class="logo" :src="logo" mode="heightFix"></el-image>
      <el-image
        class="logo logo-white"
        :src="logoWhite"
        mode="heightFix"
      ></el-image>
      <div class="flex">
        <div class="header-title">参展商自助服务系统</div>
        <div class="cz flex" style="align-items: center">
          <div class="headertips">
            <span class="wcz"></span>
            <span>未操作</span>
          </div>
          <div class="headertips">
            <span class="jxz"></span>
            <span>进行中</span>
          </div>
          <div class="headertips">
            <span class="wtg"></span>
            <span>未通过</span>
          </div>
          <div class="headertips">
            <span class="ytg"></span>
            <span>已跳过</span>
          </div>
          <div class="headertips">
            <span class="ywc"></span>
            <span>已完成</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div @click="tapdiscussion" class="cypx" v-if="menu_switch=='NHNE'||menu_switch=='ALL'">未来营养超市活动报名</div>
        <div class="username">登录名：{{ userInfor.username }}</div>
        <div class="border">公司：{{ userInfor.name_cn }}</div>
        <div class="pointer logout" @click="logout">
          退出
          <el-image
            class="ex-image"
            :src="exitIcon"
            style="width: 14px; height: 14px; margin-left: 3px"
          ></el-image>
          <el-image
            class="ex-image2"
            :src="exitIcon2"
            style="width: 14px; height: 14px; margin-left: 3px"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { logOut } from "@/api/api";
export default {
  data() {
    return {
      logo: require("../assets/logo.jpg"),
      logoWhite: require("../assets/logo_white.jpg"),
      exitIcon: require("../assets/exit_1.png"),
      exitIcon2: require("../assets/exit_2.png"),
      userInfor: {},
      menu_switch: "",
    };
  },
  mounted() {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    this.menu_switch = sessionStorage.getItem("menu_switch");
    this.userInfor = userdata;
  },
  created() {},
  methods: {
    // 是否有新站内信消息
    isNewMessage() {
      this.$alert("<strong>这是 <i>HTML</i> 片段</strong>", "紧急通知", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        center: true,
        confirmButtonText: "我已阅读并知晓",
        confirmButtonClass: "messagebtn",
      });
    },
    // 跳转到消息列表
    toMessage() {
      this.$router.push({
        path: "/messageList",
      });
    },
    logout() {
      this.$confirm("确定要退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          logOut()
            .then((res) => {
              console.log(res, "======退出");
              if (res.data.code == 1) {
                let loginRes = {
                  token: null,
                  isLogin: false,
                };
                this.$store.commit("userStatus", loginRes);
                localStorage.clear();
                sessionStorage.removeItem('currentProductPage');
                // 状态保持清除后刷新页面
                window.location.reload();
                this.$router.push({
                  path: "/login",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    // 跳转到评奖
    tapdiscussion() {
      this.$router.push({
        name: "discussionindex",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .cypx {

    height: 30px;
    line-height: 30px;
    background: #fc9749;
    border-radius: 4px;
    border: 1px solid #fc9749;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    text-align: center;

  cursor: pointer;
  margin-right: 10px;
}
.headertips {
  margin-right: 10px;
  font-size: 16px;
}
.headertips span:nth-child(1) {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.headertips span:nth-child(2) {
}
.wcz {
  background: #c0c4cc;
}
.jxz {
  background: #faad14;
}
.wtg {
  background: red;
}
.ytg{
  background: #5de6dd;
}
.ywc {
  background: #1ac484;
}
.header {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px 0 30px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 999;
  .logo {
    width: 50px;
    // height: 62px;
    // line-height: 62px;
    text-align: center;
    margin-left: 38px;
  }
  .logo-white {
    display: none;
  }
  .header-title {
    font-size: 30px;
    font-weight: bold;
    color: #2c2c2e;
    margin: 0 40px 0 60px;
  }
  .right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    color: #2c2c2e;
    > div {
      padding: 0 20px;
    }
    .message {
      position: relative;
      .message-tips {
        position: absolute;
        top: -4px;
        right: 15px;
        width: 16px;
        height: 16px;
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        border-radius: 50%;
        text-align: center;
        background: #ff4d4f;
      }
    }
    .border {
      border: 1px solid #848489;
      border-top: 0 none;
      border-bottom: 0 none;
      margin-right: 10px;
    }
    .pointer {
      cursor: pointer;
    }
    .logout {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 66px;
      height: 26px;
      padding: 0;
      background: #fff;
      transition: all 0.2s;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
      border-radius: 5px;
      .ex-image2 {
        display: none;
      }
    }
    .logout:hover {
      color: #fff;
      background: #2c2c2e;
      text-decoration: underline;
      .ex-image {
        display: none;
      }
      .ex-image2 {
        display: block;
      }
    }
  }
}
.messagebtn {
  width: 146px;
  height: 40px;
  overflow: hidden;
  font-size: 16px;
  border: 0 none !important;
  background: #2c2c2e !important;
  border-radius: 5px;
}
@media (max-width: 1366px) {
  .header-title {
    font-size: 24px !important;
    margin: 0 30px 0 34px !important;
  }
}
@media (max-width: 1024px) {
  .header-title {
    font-size: 20px !important;
    margin: 0 30px 0 34px !important;
  }
  .header .right > div {
    padding: 0px 9px;
  }
}
@media only screen and (max-width: 767px) {
  .header {
    height: 60px;
    padding: 0 18px 0 15px;
    background: #2c2c2e;
    justify-content: inherit;
    .header-title {
      display: none;
    }
    .cz {
      display: none;
    }
    .username {
      display: none;
    }
    .border {
      display: none;
    }
    .right {
      color: #fff;
      position: relative;
      justify-content: inherit;
      font-size: 12px !important;
      > div {
        padding: 0 6px;
      }
      .border {
        border-color: #fff;
      }
      .logout {
        color: #2c2c2e;
        position: absolute;
        right: 0;
      }
    }
    .logo {
      display: none;
    }
    .logo-white {
      width: 30px;
      margin-left: 0;
      // height: 30px;
      display: block;
    }
  }
  .header .right > div {
    margin-left: 10px;
  }

}
</style>
